import SurveyLocationUpload from "./SurveyLocationUpload";

export default SurveyLocationUpload;
